import AccountSettings from './AccountSettings';
import connect from './connect';

export default connect(AccountSettings);
export { default as EmailSettings } from './EmailSettings';
export { default as FontSettings } from './FontSettings';
export { default as PasswordSettings } from './PasswordSettings';
export { default as ReferralsSettings } from './ReferralsSettings';
export { default as SubscriptionSettings } from './SubscriptionSettings';
